export default {
  // 水瓶
  aquarius: {
    watch: 'watch-silver-2',
    name: '浪琴表巨擘系列年曆銀色面盤點鑽時標腕錶',
    people: ['巴菲特', '村上春樹', 'Kobe Bryant'],
    quotes: ['如果你屬於人類中那最幸運的1%，那麼你就應該考慮其他99%的人，這是你應該做的。', '該上之時，瞄準最高的塔上到塔尖；該下之時，找到最深的井下到井底。', '最重要的事就是去努力嘗試與激勵大家，使他們能夠在想做的事上大放異彩。'],
    comments: ['好險我是那1%的小幸運！', '做任何事，別當半吊子。', '別當個自私鬼，你身邊還有其他人。']
  },
  // 雙子
  gemini: {
    watch: 'watch-silver-2',
    name: '浪琴表巨擘系列年曆銀色面盤點鑽時標腕錶',
    people: ['歐普拉', '馬雲', '比爾蓋茲'],
    quotes: ['於你所擁有的，要心存感激，這樣你就會擁有更多。對於你所沒有的，如果不停強調，你永遠都不會滿足。', '人要有專注的東西，人一輩子走下去挑戰會更多，你天天換，我就怕了你。', '有非凡志向，才有非凡成就。'],
    comments: ['簡而言之就是不要「吃碗內、看碗外」。', '變來變去，是魔術師不成？', '你還在懷抱小確幸？']
  },
  // 天秤
  libra: {
    watch: 'watch-silver-2',
    name: '浪琴表巨擘系列年曆銀色面盤點鑽時標腕錶',
    people: ['愛因斯坦', '奧黛麗赫本', 'Kobe Bryant'],
    quotes: ['人生就像騎自行車，為了讓自己保持平衡，你必需向前邁進。', '優雅是唯一不會褪色的美。', '我從人群學習，得到很多借鏡。'],
    comments: ['不前進，請做好摔跤的準備。', '氣質是妝不出來的。', '還好我天生愛交朋友。']
  },
  // 雙魚
  pisces: {
    watch: 'watch-blue',
    name: '浪琴表巨擘系列年曆藍色太陽紋腕錶',
    people: ['歐普拉', '村上春樹', 'Kobe Bryant'],
    quotes: ['幸運，其實就是準備遇到了機會。', '每個人都有屬於自己的一片森林，迷失的人迷失了，相逢的人會再相逢。', '如果你害怕失敗，那你很有可能會失敗。'],
    comments: ['原來大富翁蘊含了人生哲理。', '若正在森林中迷失，不妨用心去感受一切。', '氣勢決定你的架勢！']
  },
  // 巨蟹
  cancer: {
    watch: 'watch-blue',
    name: '浪琴表巨擘系列年曆藍色太陽紋腕錶',
    people: ['巴菲特', '李安', '比爾蓋茲'],
    quotes: ['如果我們不能在自己有信心的範圍內找到需要的，我們不會擴大範圍。我們只會等待。', '這世界上唯一扛的住歲月摧殘的就是才華。', '一旦做出決定就不要拖延。任何事情想到就去做！立即行動！'],
    comments: ['Leave me alone！別再叫我跳出舒適圈！', '充實自己才是最可靠的方法。', '大部分的人都喜歡拖延，因為事情往往只停留在想像階段。']
  },
  // 天蠍
  scorpio: {
    watch: 'watch-blue',
    name: '浪琴表巨擘系列年曆藍色太陽紋腕錶',
    people: ['馬雲', '愛因斯坦', '奧黛麗赫本'],
    quotes: ['建立自我、追求忘我。', '一個人的價值，在於他貢獻了什麼，而不在於他能得到什麼。', '要有迷人的雙唇，請常說善意的語言。'],
    comments: ['接下來是超越自我、追求無我。', '要得到回報，你得先付出！', '別輕忽說好話的力量。']
  },
  // 牡羊
  aries: {
    watch: 'watch-black',
    name: '浪琴表巨擘系列年曆黑色麥穗紋腕錶',
    people: ['馬雲', '愛因斯坦', 'Kobe Bryant'],
    quotes: ['不要怕對手比你有條件，比你強大，如果你是全世界最想做成這件事的人，你就有機會贏。', '我從不去想未來。因為它來得已經夠快的了。', '我願意做任何能夠贏得比賽的事，即使只是坐在板凳上擰毛巾、遞茶水給隊員，或投出致勝一球。'],
    comments: ['用念力改變命運！', '有時候放慢腳步也很好。', '真正想達成的目標，不會只在嘴上說說。']
  },
  // 獅子
  leo: {
    watch: 'watch-black',
    name: '浪琴表巨擘系列年曆黑色麥穗紋腕錶',
    people: ['村上春樹', '奧黛麗赫本', '李安'],
    quotes: ['剛剛好，看見你幸福的樣子，於是幸福著你的幸福。', '優美的姿態，來源于與知識同行，而不是獨行。', '我們能觸摸的東西沒有「永遠」。把手握緊，裡面什麼也沒有；把手鬆開，你擁有的是一切。'],
    comments: ['自私的愛不是愛。', '想要獲得讓人讚賞的外在，請先充實你的內在。', '放下吧！你將獲得更多。']
  },
  // 射手
  sagittarius: {
    watch: 'watch-black',
    name: '浪琴表巨擘系列年曆黑色麥穗紋腕錶',
    people: ['巴菲特', '歐普拉', '比爾蓋茲'],
    quotes: ['時間是精彩事業的朋友，但卻是平庸事業的敵人。', '你能經歷的最大冒險，就是過你夢想的生活。', '人生的選擇決定一切。'],
    comments: ['難怪，最熱賣的永遠是「經典款」。', '夢想不要亂定義，風險很大。', '做重要決定的時候別太衝動。']
  },
  // 金牛
  taurus: {
    watch: 'watch-silver-1',
    name: '浪琴表巨擘系列年曆銀色麥穗紋腕錶',
    people: ['馬雲', '愛因斯坦', '李安'],
    quotes: ['做任何事，必須要有突破，沒有突破，就等於沒做。', '不要為成功而努力，要為做一個有價值的人而努力。', '人生不能像做菜，把所有的料都準備好了才下鍋。'],
    comments: ['人生雖已看破，仍要突破。', '你的價值，決定你的價格。', '人生最有趣的地方，就在於充滿了未知。']
  },
  // 處女
  virgo: {
    watch: 'watch-silver-1',
    name: '浪琴表巨擘系列年曆銀色麥穗紋腕錶',
    people: ['巴菲特', '奧黛麗赫本', '李安'],
    quotes: ['做優秀的投資者並不需要高智商，只須擁有不輕易從眾的能力。', '我當然不會試圖摘月，我要月亮奔我而來。', '壓抑只會讓感情更強烈。'],
    comments: ['盲從，那你就是普通人！', '花若盛開，蝴蝶自來，人若精彩，天自安排。', '讓感情的能量正常釋放吧！']
  },
  // 摩羯
  capricornus: {
    watch: 'watch-silver-1',
    name: '浪琴表巨擘系列年曆銀色麥穗紋腕錶',
    people: ['歐普拉', '村上春樹', '比爾蓋茲'],
    quotes: ['這一刻全力以赴，下一刻成就最佳。', '有希望之處定有磨練。', '在這個世界上，沒有人能使你倒下，如果你自己的信念還站立的話。'],
    comments: ['人生一刻都不能放鬆啊～', '世上沒有天上掉下來的禮物。', '沒有信念的人，站著躺著隨便你。']
  }
}
